import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';
@Component({
  selector: 'cs2-placements',
  templateUrl: './cs2-placements.component.html'
})
export class Cs2PlacementsComponent {
  service = 'placements';
  availableServices = services['cs2'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'cs2',
    service: 'placements',
    type: 'solo',
    title: {
      en: 'Placements',
    },
    queue: 'premier',
    subtitle: {
      en: 'Win 10 Placements in 15 games or less, in Premier or Competitive Queue',
      fr: 'Gagnez 10 games de Placement en 15 games ou moins, en mode Premier ou Compétitif',
      de: 'Gewinne 10 Platzierungen in 15 Spielen oder weniger, in der Premier oder Competitive Queue',
      pt: "Ganha 10 Placements em 15 jogos ou menos, em Premier ou Competitive",
      es: 'Gana 10 clasificaciones en 15 partidas o menos, en Premier o Competitive Queue',
    },
    start: 0,
    desired: 10,
    serviceName: 'Wins',
    min: 1,
    max: 10
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A Placements Boosting Service?",
        answer: "Placements is a sort of CS Rating boost that guarantees 10 Premier or Competitive Wins within 15 games. If fewer than 10 victories are required, a different outcome may apply."
      },
      {
        question: "What If I Dont Get 10 Wins in 15 Games?",
        answer: "Our average result in placements matches is above that, but in case we go below our guaranteed minimum we will grant you a compensation in the form of Net Wins. The number of Net Wins awarded depends on the final result."
      },
      {
        question: "I Already Have One Or More Wins, Can I Still Buy Placements?",
        answer: "Indeed, you can. Simply select the number of remaining placement wins in the banner above, and we will begin immediately."
      },
      {
        question: "Can I Play Together With The Booster?",
        answer: "Yes, you can. To make it happen, click on the \"Duo\" button in the order additions menu."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, you can pause your order and play another queue other than the one you purchased. Simply schedule it in the order chat with your booster."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un service de Boosting de Placement?",
        answer: "Placement est une sorte de boost de rang CS qui garantit 10 victoires en Premier ou en Compétitif en 15 games. Si moins de 10 victoires sont requises, le résultat peut être différent."
      },
      {
        question: "Et si je n\'obtiens pas 10 victoires en 15 games?",
        answer: "Notre résultat moyen dans les matchs de placement est supérieur à celà, mais si nous descendons en dessous de notre minimum garanti, nous vous accorderons une compensation sous forme de Victoires Nettes. Le nombre de victoires nettes accordées dépend du résultat final."
      },
      {
        question: "J\'ai déjà remporté une ou plusieurs games, puis-je encore acheter le boost placement?",
        answer: "En effet, vous pouvez le faire. Il vous suffit de sélectionner le nombre de games de placement restantes dans la bannière ci-dessus, et nous commencerons immédiatement."
      },
      {
        question: "Puis-je jouer avec le booster?",
        answer: "Certainement ! Vous pouvez le faire en cliquant sur le bouton rouge \"DUO\" dans le menu des ajouts à la commande."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, vous pouvez interrompre votre commande et jouer dans un autre mode de jeu que celle que vous avez achetée. Il vous suffit de le programmer dans le chat de la commande avec votre booster."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
        }
    ],
    de: [
      {
        question: "Was ist ein Placements Boosting Service?",
        answer: "Placements ist eine Art von CS Rating Boost, die 10 Premier- oder Competitive-Siege innerhalb von 15 Spielen garantiert. Wenn weniger als 10 Siege erforderlich sind, kann ein anderes Ergebnis gelten."
      },
      {
        question: "Was ist, wenn ich in 15 Spielen keine 10 Siege erziele?",
        answer: "Unser durchschnittliches Ergebnis in den Platzierungsspielen liegt über diesem Wert. Sollten wir jedoch unter das garantierte Minimum fallen, vergeben wir eine Entschädigung in Form von Net Wins. Die Anzahl der Net Wins hängt vom Endergebnis ab."
      },
      {
        question: "Ich habe bereits einen oder mehrere Siege. Kann ich trotzdem Platzierungen kaufen?",
        answer: "Ja, das kannst du. Wähle einfach die Anzahl der verbleibenden Platzierungsgewinne im Banner oben aus, und wir beginnen sofort."
      },
      {
        question: "Kann ich mit dem Booster zusammen spielen?",
        answer: "Ja, das kannst du. Dazu klickst du auf die Schaltfläche \"Duo\" im Menü der Bestellungszusätze."
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich denselben Booster für zukünftige Käufe anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      }
    ],
    pt: [
      {
        question: "O Que É Um Serviço De CS2 Placements Boost?",
        answer: "Placements Boost é um tipo serviço que garante 10 vitórias em Premier ou Competitive em 15 jogos ou menos. Sendo necessárias menos de 10 vitórias, um resultado diferente pode aplicar-se."
      },
      {
        question: "E se eu não conseguir 10 vitórias em 15 jogos?",
        answer: "Caso fiquemos abaixo do nosso mínimo garantido, concedemos uma compensação na forma de Net Wins. O número de Net Wins concedidas depende do resultado final."
      },
      {
        question: "Já tenho uma ou mais vitórias, ainda posso comprar placemetns?",
        answer: "Sim, podes. Basta selecionar o número de vitórias de placements restantes no banner acima, e começaremos imediatamente."
      },
      {
        question: "Posso Jogar Com O Booster Em Duo?",
        answer: "Sim, podes. Para fazer isso, clica no botão \"Duo\" no menu de adições de pedidos."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, podes colocar em pausa o teu pedido e jogar numa queue diferente da que compras-te. Basta agendar no chat do pedido com o teu booster."
      },
      {
        question: "Posso pedir o mesmo booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      }
    ],
    es: [
      {
        question: "¿Qué es un servicio de Boost de clasificación?",
        answer: "Las Clasificaciones son una especie de Boost de clasificación CS que garantiza 10 victorias Premier o Competitivas en 15 partidas. Si se requieren menos de 10 victorias, puede aplicarse un resultado diferente."
      },
      {
        question: "¿Y si no consigo 10 victorias en 15 partidos?",
        answer: "Nuestro resultado medio en los partidos de clasificación está por encima de eso, pero en caso de que quedemos por debajo de nuestro mínimo garantizado, te concederemos una compensación en forma de Ganancias Netas. El número de Ganancias Netas concedidas depende del resultado final."
      },
      {
        question: "Ya tengo una o más victorias, ¿puedo seguir comprando clasificaciones?",
        answer: "Efectivamente, puedes hacerlo. Sólo tiene que seleccionar el número de victorias de clasificación restantes en el banner de arriba, y comenzaremos inmediatamente."
      },
      {
        question: "¿Puedo jugar con los boosters?",
        answer: "Sí, puedes hacerlo. Para ello, haz clic en el botón \"Duo\" del menú de añadir pedidos."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, puedes pausar tu pedido y jugar en otra cola que no sea la que has comprado. Solo tienes que programarlo en el chat de pedidos con tu boosters."
      },
      {
        question: "¿Puedo solicitar al mismo booster para una compra futura?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }
    ]
  }

  private page = {
    title: {
      en: "Counter Strike 2 | Premier Placements Boosting Services",
      fr: "Counter Strike 2 | Services de Boosting de Placement Premier",
      de: "Counter Strike 2 | Premier-Platzierungs-Boosting-Dienste",
      pt: "Counter Strike 2 | Serviços de Boosting de Placements Premier",
      es: "Counter Strike 2 | Servicios de Boosting de Colocaciones Premier"
    },
    metaDescription: {
      en: "Start your Counter Strike 2 Premier Placements on Top with GGBoost. Opt for the Best and Safest Boosting Services, ensuring Top Tier Performance Every Match",
      fr: "Commencez vos Placements Premier de Counter Strike 2 en tête avec GGBoost. Optez pour les meilleurs services de boosting, assurant une performance de premier niveau à chaque match.",
      de: "Starten Sie Ihre Counter Strike 2 Premier-Platzierungen mit GGBoost. Wählen Sie die besten und sichersten Boosting-Dienste, die in jedem Spiel erstklassige Leistungen garantieren.",
      pt: "Começa os teus placemetns Premier de Counter Strike 2 no topo com GGBoost. Opta pelos melhores e mais seguros serviços de boosting, garantindo desempenho de alto nível em cada partida.",
      es: "Comience sus Colocaciones Premier de Counter Strike 2 en la cima con GGBoost. Opte por los mejores y más seguros servicios de boosting, asegurando un rendimiento de primer nivel en cada partida."
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}